import React from 'react';
import { motion } from 'framer-motion';
import { Diamond } from 'lucide-react';
interface SectionDividerProps {
  className?: string;
}
export function SectionDivider({
  className = ''
}: SectionDividerProps) {
  return <motion.div initial={{
    opacity: 0
  }} whileInView={{
    opacity: 1
  }} viewport={{
    once: true
  }} transition={{
    duration: 1
  }} className={`flex items-center justify-center gap-4 py-8 md:py-10 ${className}`} aria-hidden="true" data-id="element-361">
      <div className="gold-divider w-32 md:w-48" data-id="element-362" />
      <Diamond size={10} stroke="url(#riamGold)" fill="url(#riamGoldFill)" className="icon-glow rotate-45" data-id="element-363" />
      <div className="gold-divider w-32 md:w-48" data-id="element-364" />
    </motion.div>;
}